<template>
    <div class="p-30 pt-10">

        <div class="flex jc-sb mb-20">
            <el-button size="small">返回</el-button>
        </div>

        <div class="flex jc-sb mb-20">

            <div class="flex jc-fs">
                <div>小组名称：</div>
                <el-input style="width: 300px;" v-model="val" placeholder="请输入小组名称"></el-input>
            </div>

            <div>
                <el-button type="primary" @click="search()">
                    <i class="el-icon-search" style="margin-right: 5px;"></i>查询
                </el-button>
                <el-button @click="search('refresh')">
                    <i class="el-icon-refresh" style="margin-right: 5px;"></i>重置
                </el-button>
            </div>

        </div>

        <div class="flex jc-sb mb-20">
            <el-button type="primary" plain>新建小组</el-button>
        </div>

        <dyTable v-if="studentList.length > 0" ref="table" :columns="columns" :table-data="studentList"
            v-loading="tableLoading" :total="total" :page-num="pageNo" :page-size="pageSize"
            @current-change="pageNoChange" element-loading-text="加载中">
        </dyTable>


        <el-dialog title="小组信息" :visible.sync="infoDialog" width="500px">

            <el-form label-width="60px">
                <el-form-item label="小组名称：">
                    <el-input style="width: 300px;" v-model="val" placeholder=""></el-input>
                </el-form-item>
            </el-form>

            <div class="flex jc-fe">
                <el-button type="primary" plain>确定</el-button>
                <el-button plain>取消</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
import { queryUserInfo, findAllSchool, updateUserDetail, queryUserDetails } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import dyTable from '@/components/common/dytable'


export default {
    name: 'approvalList',
    components: {
        dyTable
    },
    computed: {

    },
    data() {
        return {
            loading: false,

            classInfo: {},

            tableLoading: false,
            infoDialog: false,

            val: "",
            columns: [],
            studentList: [{}],
            pageNo: 1,
            pageSize: 10,
            total: 100,




        };
    },
    created() {
        let param = {}
        if (this.$route.query.param) {
            param = JSON.parse(decrypt(this.$route.query.param))
        }
        this.classInfo = param.classInfo || {};
        console.log('classInfo :>> ', this.classInfo);
    },
    mounted() {
        this.columns = [
            {
                type: 'index',
                title: '序号'
            },
            {
                key: 'textName',
                title: '小组名称'
            },
            {
                key: 'bgUserName',
                title: '创建时间'
            },
            {
                key: '',
                title: '操作',
                width: 300,
                render: ({ row }) => {
                    return (
                        <div>
                            <el-link type="primary" onClick={() => this.detail(row)}>编辑</el-link>
                            <el-link type="primary" style="margin-left:12px" onClick={() => this.member(row)}>组员管理</el-link>
                            <el-link type="danger" style="margin-left:12px" onClick={() => this.delete(row)}>解散小组</el-link>
                        </div>
                    );
                }
            },
        ];

    },

    methods: {

        pageNoChange() {

        },

        detail() {
            this.infoDialog = true;
        },

        member() {

        },


    }
};
</script>

<style lang='scss' scoped></style>
